import React from 'react';
import { useTranslation } from 'react-i18next';
import './LanguageSwitcher.css';

function LanguageSwitcher() {
  const { i18n } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  return (
    <div className="language-switcher">
      <button 
        className={i18n.language === 'en' ? 'active' : ''} 
        onClick={() => changeLanguage('en')}
      >
        English
      </button>
    <p>|</p>
      <button 
        className={i18n.language === 'zh' ? 'active' : ''} 
        onClick={() => changeLanguage('zh')}
      >
        简体中文
      </button>
    </div>
  );
}

export default LanguageSwitcher;